import React from 'react';
import { Col, Hidden, Row, Visible, Container } from 'react-grid-system'
import cn from 'classnames';
import styles from './Skeleton.module.scss';
import { PAGES } from 'routes/PAGES';
import SearchThinkingCards from 'features/search/SearchThinkingCards';
import MatchCardsSkeleton from 'pages/ContactList/MatchCardsSkeleton';
import JobsSkeleton from 'pages/VacancyList/JobsSkeleton';
import ProfileSkeleton from 'pages/Profile/ProfileSkeleton';

const Filters = () => {
    return <>
        <div className={styles.filter} data-loading="true" style={{ width: "102px" }} />
        <div className={styles.filter} data-loading="true" style={{ width: "144px" }} />
        <div className={styles.filter} data-loading="true" style={{ width: "122px" }} />
    </>
}

const AvatarCol = () => {
    return <Col xs={4} md={3} className={styles.col}>
        <div className={styles.avatars}>
            <div className={styles.avatar}></div>
        </div>
    </Col>
}

const RequestCol = () => {
    return <Col xs={12} className={styles.col} style={{ paddingRight: 0 }}>
        <div className={styles.cards}>
            <div className={styles.panel} style={{ height: "172px" }}></div>
            <div className={styles.panel} style={{ height: "172px" }}></div>
        </div>
    </Col>
}

const TitleCol = ({ showButton = true, style }) => {
    return <Col xs={12} lg={7} xl={6} className={styles.col} style={style}>
        <div className={styles.title}>
            <div className={styles.text}></div>
            {showButton && <Hidden lg xl>
                <div className={styles.button}></div>
            </Hidden>}
        </div>
    </Col>
}

const TextCol = () => {
    return <Col xs={8} md={6} className={styles.col}>
        <div className={styles.texts}>
            <div className={styles.label}></div>
            <div className={styles.label}></div>
            <div className={styles.text}></div>
            <div className={styles.tags}>
                <div className={styles.tag}></div>
                <div className={styles.tag}></div>
                <div className={styles.tag}></div>
                <div className={styles.tag}></div>
            </div>
        </div>
    </Col>
}

const ButtonCol = () => {
    return <Col md={3} className={styles.col}>
        <div className={styles.label}></div>
        <div className={styles.buttons}>
            <div className={styles.button}></div>
            <div className={styles.button}></div>
        </div>
    </Col>
}

const SurveyTitleCol = () => {
    return <Col xs={12} className={styles.col}>
        <div className={styles.text}></div>
        <div className={styles.label}></div>
    </Col>
}

const SurveyAnswersCol = () => {
    return <Col xs={12} className={styles.col}>
        <div className={styles.pills}>
            <div className={styles.pill} style={{ width: "70px" }}></div>
            <div className={styles.pill} style={{ width: "30px" }}></div>
            <div className={styles.pill} style={{ width: "50px" }}></div>
        </div>
        <div className={styles.pills}>
            <div className={styles.pill} style={{ width: "140px" }}></div>
            <div className={styles.pill} style={{ width: "60px" }}></div>
            <div className={styles.pill} style={{ width: "30px" }}></div>
        </div>
    </Col>
}

const SurveyButtonCol = () => {
    return <Col xs={12} sm={6} className={styles.col}>
        <div className={styles.profileButtons}>
            <div className={styles.input}></div>
        </div>
    </Col>
}

const NameCol = () => {
    return <Col xs={6} md={3} className={cn(styles.col, styles.nameCol)} style={{ justifyContent: "center", gap: "20px" }}>
        <Hidden xs >
            <div className={styles.text}></div>
        </Hidden>
        <div className={styles.label}></div>
        <div className={styles.label}></div>
    </Col>
}

const ActionButtonsCol = () => {
    return <Col xs={4} md={6} className={styles.col} style={{ alignItems: "flex-end", justifyContent: "center" }}>
        <div className={styles.buttons}>
            <div className={styles.button}></div>
            <div className={styles.button}></div>
            <div className={styles.button}></div>
        </div>
        <div className={styles.tag} style={{ maxWidth: "144px" }}></div>
    </Col>
}

const Wrapper = ({ useContainer, children }) => {
    return useContainer ? <Container className={styles.gridContainer}>{children}</Container> : <div>{children}</div>;
}

const Skeleton = ({ page, component, useContainer }) => {
    if (component === "Filter") {
        return <Filters />
    }
    if (page == "RequestsMobile") {
        return <Wrapper useContainer={useContainer}>
            <div className={styles.skeleton}>
                <Row className={styles.row} style={{ marginBottom: "6px" }}>
                    <RequestCol />
                </Row>
            </div>
        </Wrapper>
    }
    if (page === PAGES.FULL_PARTICIPANT_VIEW) {
        return <Wrapper useContainer={useContainer}>
            <div className={styles.memberCard}>
                <div className={styles.memberTop}>
                    <div className={cn(styles.memberBone, styles.memberAvatar)} />
                    <div className={styles.memberLines}>
                        <div className={cn(styles.memberBone, styles.memberName)} />
                        <div className={cn(styles.memberBone, styles.memberLine)} />
                        <div className={cn(styles.memberBone, styles.memberLine)} />
                    </div>
                    <div className={cn(styles.memberBone, styles.memberAction)} />
                </div>
                <div className={styles.memberLines}>
                    <div className={cn(styles.memberBone, styles.memberLine)} />
                    <div className={cn(styles.memberBone, styles.memberLine)} />
                </div>
                <div className={styles.memberTags}>
                    <div className={cn(styles.memberBone, styles.memberTag)} />
                    <div className={cn(styles.memberBone, styles.memberTag, styles.memberTagWide)} />
                    <div className={cn(styles.memberBone, styles.memberTag, styles.memberTagShort)} />
                </div>
            </div>
        </Wrapper>
    }

    if (page === PAGES.QUESTIONS || page === PAGES.ONBOARDING) {
        return <Wrapper useContainer={useContainer}>
            <div className={cn(styles.skeleton, styles.surveySkeleton)}>
                <Row className={styles.row}><></></Row>
                <Row className={styles.row}>
                    <SurveyTitleCol />
                </Row>
                <Row className={styles.row}>
                    <SurveyAnswersCol />
                </Row>
                <Row className={styles.row}><></></Row>
                <Row className={styles.row}>
                    <SurveyButtonCol />
                    <SurveyButtonCol />
                </Row>
            </div>
        </Wrapper>
    }

    if (page === PAGES.PROFILE) {
        return (
            <Wrapper useContainer={useContainer}>
                <ProfileSkeleton />
            </Wrapper>
        )
    }

    if (page === PAGES.EVENT_CREATE) {
        return (
            <Wrapper useContainer={useContainer}>
                <div className={styles.eventForm}>
                    <div className={styles.eventFormCrumb} />
                    <div className={styles.eventFormTitle} />
                    <div className={styles.eventFormGrid}>
                        <div className={styles.eventFormMain}>
                            <div className={styles.eventFormCard}>
                                <div className={styles.eventFormHeading} />
                                <div className={styles.eventFormField} />
                                <div className={styles.eventFormField} />
                                <div className={styles.eventFormArea} />
                            </div>
                            <div className={styles.eventFormCard}>
                                <div className={styles.eventFormHeading} />
                                <div className={styles.eventFormRow}>
                                    <div className={styles.eventFormField} />
                                    <div className={styles.eventFormField} />
                                    <div className={styles.eventFormField} />
                                </div>
                                <div className={styles.eventFormField} />
                                <div className={styles.eventFormArea} />
                            </div>
                        </div>
                        <div className={styles.eventFormSide}>
                            <div className={styles.eventFormCard}>
                                <div className={styles.eventFormImage} />
                            </div>
                        </div>
                    </div>
                </div>
            </Wrapper>
        );
    }

    if (page === PAGES.CONTACTS) {
        return (
            <Wrapper useContainer={useContainer}>
                <MatchCardsSkeleton />
            </Wrapper>
        );
    }

    if (page === PAGES.PARTICIPANTS) {
        return (
            <Wrapper useContainer={useContainer}>
                <SearchThinkingCards />
            </Wrapper>
        );
    }

    if (page === PAGES.VACANCY_LIST) {
        return <JobsSkeleton />;
    }

    return (
        <Wrapper useContainer={useContainer}>
            <div className={styles.skeleton}>
                {page === PAGES.MY_COMMUNITIES && (
                    <div className={styles.communities}>
                        <div className={styles.map} />
                        <div className={styles.communityCard}>
                            <div className={styles.cardLines}>
                                <div className={styles.cardLine} />
                                <div className={styles.cardLine} />
                                <div className={styles.cardLine} />
                            </div>
                        </div>
                        <div className={styles.communityCard}>
                            <div className={styles.cardLines}>
                                <div className={styles.cardLine} />
                                <div className={styles.cardLine} />
                            </div>
                        </div>
                    </div>
                )}
                {page === PAGES.PARTICIPANTS && (
                    <Row className={styles.row}>
                        <TitleCol showButton={false} style={{ marginBottom: "-8px" }} />
                        <Col xs={12} className={styles.col} style={{ flexDirection: 'row', gap: "8px" }}>
                            <Filters />
                        </Col>
                    </Row>
                )}
                {page !== PAGES.MY_COMMUNITIES && <>
                <Row className={styles.row}>
                    <Hidden xs sm>
                        <AvatarCol />
                        <TextCol />
                        <ButtonCol />
                    </Hidden>

                    <Visible xs sm>
                        <TextCol />
                        <AvatarCol />
                    </Visible>
                </Row>
                <Row className={styles.row}>
                    <Hidden xs sm>
                        <AvatarCol />
                        <TextCol />
                        <ButtonCol />
                    </Hidden>

                    <Visible xs sm>
                        <TextCol />
                        <AvatarCol />
                    </Visible>
                </Row>
                <Row className={styles.row}>
                    <Hidden xs sm>
                        <AvatarCol />
                        <TextCol />
                        <ButtonCol />
                    </Hidden>

                    <Visible xs sm>
                        <TextCol />
                        <AvatarCol />
                    </Visible>
                </Row>
                </>}
            </div>
        </Wrapper>
    );
};

export default React.memo(Skeleton);
